import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'https://welfaresocietybackend.insapps.in/api';

const api = axios.create({
  baseURL: API_URL,
});

export const authService = {
  setToken: (token: string | null) => {
    if (token) {
      api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    } else {
      delete api.defaults.headers.common['Authorization'];
    }
  },

  // Regular admin/supervisor login (with optional tenant code)
  login: async (mobile: string, password: string, tenantCode?: string) => {
    const payload: { mobile: string; password: string; tenantCode?: string } = { mobile, password };
    if (tenantCode) {
      payload.tenantCode = tenantCode;
    }
    const response = await api.post('/auth/login', payload);
    if (response.data.success) {
      authService.setToken(response.data.data.token);
      return {
        token: response.data.data.token,
        user: response.data.data.user,
        tenant: response.data.data.tenant || null,
      };
    }
    throw new Error(response.data.message || 'Login failed');
  },

  // Super admin login
  superAdminLogin: async (mobile: string, password: string) => {
    const response = await api.post('/super-admin/login', { mobile, password });
    if (response.data.success) {
      authService.setToken(response.data.data.token);
      return {
        token: response.data.data.token,
        user: response.data.data.user,
      };
    }
    throw new Error(response.data.message || 'Login failed');
  },

  getCurrentUser: async () => {
    const response = await api.get('/auth/me');
    return response.data.data.user;
  },

  changePassword: async (currentPassword: string, newPassword: string) => {
    const response = await api.post('/admin/change-password', {
      currentPassword,
      newPassword,
    });
    return response.data;
  },

  superAdminChangePassword: async (currentPassword: string, newPassword: string) => {
    const response = await api.post('/super-admin/change-password', {
      currentPassword,
      newPassword,
    });
    return response.data;
  },

  logout: async () => {
    try {
      await api.post('/auth/logout');
    } catch (error) {
      console.error('Logout error:', error);
    }
    authService.setToken(null);
  },
};

export default api;

